import { render, staticRenderFns } from "./TeacherClass.vue?vue&type=template&id=065650c8&scoped=true"
import script from "./TeacherClass.vue?vue&type=script&lang=js"
export * from "./TeacherClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065650c8",
  null
  
)

export default component.exports